module.exports = __webpack_public_path__ + "img/connexion_security.png";